module.exports = __webpack_public_path__ + "static/img/rcall-tips-panel-bg.a33b347.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/rcall-tips-panel-bg.png
// module id = hq0O
// module chunks = 28